import React from "react";

type AuthenticityTokenFieldProps = {
  csrfToken: string;
};

const AuthenticityTokenField: React.FC<AuthenticityTokenFieldProps> = ({
  csrfToken,
}) => <input type="hidden" name="authenticity_token" value={csrfToken} />;

export default AuthenticityTokenField;
